const TypographyStyles = `
  @font-face {
    font-family: 'Univers-Condensed';
    src: url('https://www.nts.live/css/fonts/Univers-Condensed/UniversCom-57Condensed.woff2') format('woff2'),
      url('https://www.nts.live/css/fonts/Univers-Condensed/UniversCom-57Condensed.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Univers-Condensed';
    src: url('https://www.nts.live/css/fonts/UniversLTPro-BoldCond.woff2') format('woff2'),
      url('https://www.nts.live/css/fonts/UniversLTPro-BoldCond.woff') format('woff');
    font-weight: bold;
    font-style: normal;
  }

  :root {
    --font-primary: "Univers-Condensed", Arial, sans-serif;
    --font-secondary: Arial, sans-serif;
  }

  .editorial .nts-font-primary {
    font-family: "Univers-Condensed", Arial, sans-serif;
    font-weight: normal;
    font-style: normal;
  }

  .editorial .nts-font-secondary {
    font-family: Arial, sans-serif;
    font-weight: normal;
    font-style: normal;
    letter-spacing: 0.1px;
  }

  .editorial .heading {
    font-weight: bold;
    text-transform: uppercase;
  }

  .editorial .button {
    font-weight: bold;
    text-transform: uppercase;
  }

  .editorial .heading-1 {
    font-size: 42px;
    line-height: 42px;
  }

  .editorial .heading-2 {
    font-size: 38px;
    line-height: 38px;
  }

  .editorial .heading-3 {
    font-size: 34px;
    line-height: 36px;
  }

  .editorial .heading-4 {
    font-size: 28px;
    line-height: 32px;
  }

  .editorial .heading-5 {
    font-size: 24px;
    line-height: 28px;
  }

  .editorial .heading-6 {
    font-size: 18px;
    line-height: 20px;
  }

  .editorial .subheading-l {
    font-size: 16px;
    line-height: 21px;
  }

  .editorial .subheading-m {
    font-size: 13px;
    line-height: 18px;
  }

  .editorial .subheading-s {
    font-size: 12px;
    line-height: 17px;
  }

  // Body
  .editorial .body-m {
    font-size: 16px;
    line-height: 21px;
  }

  .editorial .body-s {
    font-size: 13px;
    line-height: 18px;
  }

  .editorial .button-l {
    font-size: 16px;
    line-height: 18px;
  }

  .editorial .button-m {
    font-size: 14px;
    line-height: 16px;
  }

  .editorial .button-s {
    font-size: 12px;
    line-height: 14px;
  }

  .editorial .button-xs {
    font-size: 13px;
    line-height: 18px;
  }
`

export default TypographyStyles
